const BASE_URL = '/v1';

export const APPLY_COUPON = `${BASE_URL}/coupons/apply`;
